export default "__VITE_ASSET__7QjY94Ap__"